import { AdminRole } from "../types";
import { GranularScope, Scope } from "./useRolePermission/types";

export const permissionsMap: Partial<
  Record<Scope | GranularScope, AdminRole[]>
> = {
  "brandsAndPages:read": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "brandsAndPages:translations:read": [AdminRole.Translator],
  "brandsAndPages:write": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "brandsAndPages:translations:write": [AdminRole.Translator],

  "tags:read": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "tags:translations:read": [AdminRole.Translator],
  "tags:write": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "tags:translations:write": [AdminRole.Translator],

  "themeTags:read": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "themeTags:translations:read": [AdminRole.Translator],
  "themeTags:write": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "themeTags:translations:write": [AdminRole.Translator],

  "studios:read": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "studios:translations:read": [AdminRole.Translator],
  "studios:write": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "studios:translations:write": [AdminRole.Translator],

  "moduleTemplates:read": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "moduleTemplates:translations:read": [AdminRole.Translator],
  "moduleTemplates:write": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "moduleTemplates:translations:write": [AdminRole.Translator],

  "games:read": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "games:translations:read": [AdminRole.Translator],
  "games:write": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "games:translations:write": [AdminRole.Translator],

  "faq:read": [
    AdminRole.CSOperator,
    AdminRole.ContentAdmin,
    AdminRole.SuperAdmin,
  ],
  "faq:translations:read": [AdminRole.Translator],
  "faq:write": [AdminRole.CSOperator, AdminRole.SuperAdmin],
  "faq:translations:write": [AdminRole.Translator],

  "bulletinBoard:read": [
    AdminRole.CSOperator,
    AdminRole.ContentAdmin,
    AdminRole.SuperAdmin,
  ],
  "bulletinBoard:translations:read": [AdminRole.Translator],
  "bulletinBoard:write": [AdminRole.CSOperator, AdminRole.SuperAdmin],
  "bulletinBoard:translations:write": [AdminRole.Translator],

  "translations:read": [
    AdminRole.CSOperator,
    AdminRole.Translator,
    AdminRole.ContentAdmin,
    AdminRole.SuperAdmin,
  ],
  "translations:write": [AdminRole.Translator, AdminRole.SuperAdmin],

  "rolesAndPermissions:read": [AdminRole.SuperAdmin],
  "rolesAndPermissions:write": [AdminRole.SuperAdmin],

  "customerServicesCentre:write": [AdminRole.SuperAdmin, AdminRole.CSOperator],
  "customerServicesCentre:read": [AdminRole.SuperAdmin, AdminRole.CSOperator],

  "users:write": [AdminRole.SuperAdmin],
  "users:read": [AdminRole.SuperAdmin],

  "broadcasts:write": [AdminRole.SuperAdmin],
  "broadcasts:read": [AdminRole.SuperAdmin],

  "legalDocuments:read": [
    AdminRole.SuperAdmin,
    AdminRole.ContentAdmin,
    AdminRole.Translator,
  ],
  "legalDocuments:write": [
    AdminRole.SuperAdmin,
    AdminRole.ContentAdmin,
    AdminRole.Translator,
  ],
  "contentSchedule:read": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "contentSchedule:translations:read": [AdminRole.Translator],
  "contentSchedule:write": [AdminRole.ContentAdmin, AdminRole.SuperAdmin],
  "contentSchedule:translations:write": [AdminRole.Translator],
};
